import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
    document.querySelector('#componentTop').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}



// WEBPACK FOOTER //
// ./src/app/team/team.component.ts